import '../ScaleSwiper/ScaleSwiper.stories';
import '../InfiniteSwiper/InfiniteSwiper.stories';
